'use strict'

/**
 * Project easytitle24-2.x-site
 * Created by hielo on 2019-05-01
 */

// import {security} from './security-service'

function e24SiteServices (Vue) {
	if (e24SiteServices.installed) {
	// return
	}
}

if (typeof window !== 'undefined' && window.Vue) {
	window.Vue.use(e24SiteServices)
}

export default e24SiteServices



// WEBPACK FOOTER //
// ./src/commonSite/services/index.js